module.exports = __webpack_public_path__ + "static/media/rouge.4c9c0a99.png";